import { useEffect, useRef } from 'react';
const resizeArea = (ref, maxHeight) => {
    if (ref.current) {
        ref.current.style.height = 'auto';
        ref.current.style.height = `${Math.min(ref.current.scrollHeight + 1, maxHeight)}px`;
    }
};
export const useTextareaAutoResize = ({ text, maxHeight, ref: inputRef, }) => {
    const initialMount = useRef(true);
    const ref = inputRef || useRef(null);
    useEffect(() => {
        if (!initialMount.current || !!text.length) {
            resizeArea(ref, maxHeight);
        }
        if (initialMount.current)
            initialMount.current = false;
    }, [ref, maxHeight, initialMount, text]);
    return ref;
};
//# sourceMappingURL=use-textarea-auto-resize.js.map